import React from 'react';
import { motion } from 'framer-motion';

const ServicesHero: React.FC = () => {
  return (
    <section className="relative min-h-[500px] md:min-h-[600px] lg:min-h-[700px] flex items-center overflow-hidden bg-black -mt-32">
      <div className="w-full flex flex-col lg:flex-row">
        {/* Left Side - Image */}
        <div className="w-full lg:w-1/2 h-[400px] md:h-[500px] lg:h-full relative">
          <img
            src="/pics/serviceshero.jpg"
            alt="Our Services"
            className="w-full h-full object-cover"
            loading="eager"
          />
        </div>

        {/* Right Side - Text Content */}
        <div className="w-full lg:w-1/2 flex items-center justify-center py-16 lg:py-24 px-6 sm:px-8 lg:px-12 xl:px-16 bg-black">
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <h1
              className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-6"
              style={{
                fontFamily: "'Montserrat', sans-serif",
                color: '#EF3F23',
                letterSpacing: '-0.05em'
              }}
            >
              Our Services
            </h1>
            <p
              className="text-base md:text-lg text-gray-300 leading-relaxed"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              We offer comprehensive media solutions to help your brand tell its story, engage audiences, and achieve your goals.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
